// @ts-strict-ignore
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getAllChannelsPayments } from 'services/PaymentsService'
import { Paging } from 'types/types'

interface ChannelsPaymentsApiOptions {
  paging?: Paging
  from?: string
  to?: string
  merchant?: string
  status?: string
  search?: string
  tag?: string
}

export const useChannelsPaymentsQuery = (
  paymentOptions: ChannelsPaymentsApiOptions,
  queryOptions?: Omit<UseQueryOptions<unknown>, 'queryKey' | 'queryFn'>
) => {
  const { paging, from, to, merchant, status, search, tag } = paymentOptions

  return useQuery({
    queryKey: reactQueryKeys.channelPayments(paging, from, to, merchant, status, search, tag),
    queryFn: () => getAllChannelsPayments(paging, from, to, merchant, status, search, tag),
    gcTime: 0,
    staleTime: Infinity,
    enabled: false,
    ...queryOptions,
  })
}
